export default __webpack_public_path__ + "static/media/call.f0e61e41.svg";